import React from "react";
import { $t } from '@/modules/i18n';


class PartnersDesc extends React.Component {
  render() {
    const msg = this.props.message;
    return (
      <section className="partners partnerShip">
        <div className="container">
          <h4 className="title">{$t(msg.title)}</h4>
          <div>
            {
              (msg.desc || []).map(item => 
                <div className="opportunities" key={item.title}>
                  <p className="title">{$t(item.title)}</p>
                  <ul>
                    {
                      item.desc.map(desc => <li key={desc} dangerouslySetInnerHTML={{ __html: $t(desc) }} />)
                    }
                  </ul>
                </div>
              )
            }
          </div>
        </div>
      </section>
    );
  }
}

export default PartnersDesc;